const cardItems = [
  {
    title: '古装剧必看片单',
    desc: '从《琅琊榜》到《庆余年》，盘点那些让人欲罢不能的古装经典之作。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20palace%20scene%20with%20ornate%20architecture%20and%20flowing%20silk%20curtains%2C%20warm%20golden%20candlelight%20atmosphere%2C%20traditional%20costume%20drama%20aesthetic%2C%20rich%20colors%2C%20refined%20composition&width=500&height=320&seq=cards-section-01&orientation=landscape',
    tag: '古装',
  },
  {
    title: '周末喜剧放松',
    desc: '精选高分喜剧电影，轻松一笑消除一周的疲惫，快乐就这么简单。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20living%20room%20scene%20with%20colorful%20decor%20and%20warm%20sunlight%2C%20cozy%20and%20playful%20atmosphere%2C%20positive%20and%20uplifting%20mood%2C%20casual%20entertainment%20photography%20style&width=500&height=320&seq=cards-section-02&orientation=landscape',
    tag: '喜剧',
  },
  {
    title: '韩剧甜宠合集',
    desc: '高甜预警！整理韩剧中最让人心动的浪漫名场面，单身慎入。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20style%20scene%20with%20cherry%20blossoms%20and%20soft%20pastel%20lighting%2C%20warm%20spring%20atmosphere%2C%20tender%20and%20dreamy%20mood%2C%20beautiful%20cinematic%20composition%20with%20gentle%20colors&width=500&height=320&seq=cards-section-03&orientation=landscape',
    tag: '韩剧',
  },
  {
    title: '硬核动作大片',
    desc: '肾上腺素飙升的动作片大赏，枪战、格斗、追车，全程高能无尿点。',
    img: 'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20scene%20with%20explosive%20urban%20chase%20and%20dramatic%20lighting%2C%20dynamic%20motion%20blur%2C%20warm%20explosion%20tones%20against%20dark%20cityscape%2C%20cinematic%20action%20photography%2C%20high%20energy&width=500&height=320&seq=cards-section-04&orientation=landscape',
    tag: '动作',
  },
  {
    title: '国漫崛起之路',
    desc: '从大圣归来到哪吒再到深海，看国产动画如何一步步征服观众的心。',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20animation%20style%20scene%20with%20mythical%20landscape%20and%20flowing%20ink%20brush%20art%20style%2C%20vibrant%20colors%20with%20traditional%20Chinese%20painting%20influence%2C%20epic%20and%20artistic%20composition%2C%20professional%20animation%20key%20visual&width=500&height=320&seq=cards-section-05&orientation=landscape',
    tag: '动漫',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-gray-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">热门推荐</h2>
            <p className="text-sm text-gray-500 mt-2">精心整理的优质内容，总有一款适合你</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardItems.map((item, idx) => (
              <article key={idx} className="bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-gray-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer group">
                <div className="aspect-[3/2] bg-gray-100 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-block text-xs font-medium text-brand-600 bg-brand-50 px-2.5 py-1 rounded mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-base font-bold text-gray-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}